import { Button, Col, Row, Table } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import { useState, useEffect, Fragment } from "react";
import HTTP from "../../../config/axios";
import SpecificationsModal from "./SpecificationsModal";
import { encryptLocalStorage } from "../../../config/utils/storage";
import { useLocation, useNavigate } from "react-router-dom";

const SpecificationList: React.FC<any> = ({ id, isLimited, isMobile }: { id: string; isLimited?: boolean; isMobile :boolean;}) => {
  const [specificationList, setSpecificationList] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [isMobile, setIsMobile] = useState(false); 
  
  const currentLocation = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = encryptLocalStorage.getItem("jwtToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);


 
  useEffect(() => {
  
    const getCarSpecifications = async () => {
      const specificationResponse = await HTTP.get(
        `/api/vehicle/specifications/fetch-all/${id}`
      );
      const {
        data: { status, data, msg, error },
      } = specificationResponse;
      if (status == 1) {
        const specificationDataArray: any = [];
        let dataArray: any = [];
        data.map((element: any, index: number) => {
          if (isMobile) {
            specificationDataArray.push(element);
          } else {
            if ((index + 1) % 3 == 1 && index != 0) {
              specificationDataArray.push(dataArray);
              dataArray = [];
              dataArray.push(element);
            } else {
              dataArray.push(element);
            }
            if (index + 1 === data.length) {
              specificationDataArray.push(dataArray);
            }
          }
        });
        setSpecificationList(specificationDataArray);
      } else {
        setSpecificationList([]);
      }
    };
    getCarSpecifications();
  }, [id, isMobile]);

  const openModal = () => {
    if (!isLoggedIn) {
      encryptLocalStorage.setItem("previousLoggedoutLocation", currentLocation.pathname)
      navigate("/sign-in")
    }
    else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      {!isMobile ? (
        <>
          <h3 className="text-dark is-DetailFeatures mt-3">Car specifications</h3>
          <div className="border rounded px-3">
            {specificationList &&
              specificationList.map((element: any, index: number) => {
                if (isLimited && index >= 3) {
                  return null; // Stop execution beyond the 9th loop if isLimited is true
                }
                return (

                  <Table key={index} className="mt-1">
                    <thead>
                      <tr className="custom-tr w-100">
                        {element.length>0 && element?.map((spec: any, index: number) => (
                          <th className="custom-th align-top" key={index} title={`${spec.name}${spec.unit ? ` (${spec.unit})` : ''}`} style={{ width: '33.33%' }}>
                            <p className="custom-p text-secondary fw-bold"> {spec.name}
                              {spec.unit && ` (${spec.unit})`}</p>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {element.length > 0 && element.map((spec: any, index: number) => (
                          <td key={index} className="custom-td align-top" style={{ width: '33.33%' }}>
                            <p className="is-DetailValues custom-p  fw-bold">{spec.value}</p>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </Table>
                );
              })}
            {specificationList.length != 0 ? (<div className="d-flex justify-content-end">
              <Button variant="primary" onClick={openModal} className="my-2">
                View all specifications
              </Button>
            </div>
            ) : (
              <p>No specifications added</p>
            )}
          </div>
        </>
      ) : (
        <>
            <h3 className="text-dark is-DetailFeatures pt-3 ps-0">Car specifications</h3>
          <div className="border rounded  mt-2 ">
              {specificationList &&
                specificationList.map((spec: any, index: number) => {
                  if (isLimited && index >= 9) {
                    return null; // Stop execution beyond the 9th loop if isLimited is true
                  }
                  return (
                    <Fragment key={index}  >
                      <div className="pt-2">
                        <p className="text-secondary fw-bold">
                          {spec.name} {spec.unit && `(${spec.unit})`}
                        </p>
                        <p className="is-DetailValues fw-bold">{spec.value}</p>
                      </div>
                      <div className="border-top" />
                    </Fragment>
                  );
                })}
              {specificationList.length != 0 ? (
                <div className="d-flex justify-content">
                  <Button variant="primary" onClick={openModal} className="my-2 w-100">
                    View all specifications
                  </Button>
                </div>

              ) : (
                <p>No specifications added</p>
              )}
          </div>
        </>
      )}
      {isModalOpen && (
        <SpecificationsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} id={id} />
      )}
    </>
  );
};

export default SpecificationList;
